import React from 'react';
import SolutionInstallmentExaminationPaymentCompleteWrapper from 'components/SolutionInstallmentExaminationPaymentCompleteWrapper/SolutionInstallmentExaminationPaymentCompleteWrapper';

export default function SolutionInstallmentExaminationPaymentCompleteContainer() {
    return (
        <SolutionInstallmentExaminationPaymentCompleteWrapper />
    )
}
